(ns teamoesterreich.util.sign-pad
  (:require [reagent.core :as r]
            [reagent.dom :as rdom]
            [react :as react]
            ["signature_pad" :as SignaturePad]))

(defn signature-pad [!sign-img on-save]
      ;; Atom zur Speicherung der Base64-Bilddaten für die Vorschau
      (let [pad-instance (atom nil)]
           (r/with-let [el-ref (react/useRef nil)]
                       (r/create-class
                         {:display-name "SignaturePad"

                          ;; Wird aufgerufen, sobald das DOM-Element bereit ist
                          :component-did-mount
                          (fn [this]
                              (let [canvas (.-current el-ref)]
                                   ;; Selektiere das Canvas-Element innerhalb der Komponente
                                   (when-let [canvas-el (.querySelector canvas "canvas")]
                                             ;; SignaturePad auf dem Canvas-Element instanziieren
                                             (reset! pad-instance (SignaturePad. canvas-el)))))

                          ;; Die eigentliche Render-Funktion
                          :reagent-render
                          (fn []
                              [:div {:ref   el-ref
                                     :style {:padding "20px" :max-width "500px" :margin "0 auto"}}
                               (when-not @!sign-img
                                         [:<>
                                          [:h3 "Digitale Unterschrift"]

                                          ;; Rahmen für das Canvas
                                          [:div {:style {:border "2px dashed #ccc" :border-radius "4px" :background "#f9f9f9"}}
                                           [:canvas {:width 500 :height 200 :style {:display "block" :width "100%"}}]]

                                          ;; Buttons zur Steuerung
                                          [:div {:style {:margin-top "10px" :display "flex" :gap "10px"}}
                                           [:button {:on-click (fn []
                                                                   (.clear @pad-instance)
                                                                   (reset! !sign-img nil))
                                                     :style    {:padding "8px 16px" :cursor "pointer"}}
                                            "Löschen"]

                                           [:button {:on-click (fn []
                                                                   (if (.isEmpty @pad-instance)
                                                                     (js/alert "Bitte unterschreiben Sie zuerst!")
                                                                     (do
                                                                       (reset! !sign-img (.toDataURL @pad-instance))
                                                                       (on-save (.toDataURL @pad-instance)))
                                                                     ))
                                                     :style    {:padding "8px 16px" :background "#0070f3" :color "white" :border "none" :cursor "pointer"}}
                                            "Speichern"]]])

                               ;; Vorschau des generierten Bildes
                               (when @!sign-img
                                     [:div {:style {:margin-top "20px"}}
                                      [:p "Gespeicherte Vorschau:"]
                                      [:img {:src   @!sign-img
                                             :alt   "Unterschrift Vorschau"
                                             :style {:border "1px solid #ddd" :background "#fff" :display "block" :max-width "100%"}}]])])}))))
